import * as yup from 'yup'

export interface IShipmentStopFacilityContact {
  id: number
}

/**
 * Schema for adding a facility contact to a stop object
 * @see https://fp-staging.transfix.io/api-docs/index.html#/Shipments/post_shipments
 */
export const ShipmentStopFacilityContactSchema = yup.object<IShipmentStopFacilityContact>({
  id: yup.number(),
})

export type ShipmentStopFacilityContactType = yup.InferType<
  typeof ShipmentStopFacilityContactSchema
>
